import { LogLevel } from "@azure/msal-browser";

const clientIdDev = "486f859e-c49b-4763-86b4-5c9424b3b0f6";
const clientIdProd = "486f859e-c49b-4763-86b4-5c9424b3b0f6";

// Obtener el origen base de la aplicación
const appOrigin = window.location.origin;
const path = window.location.href;

// URLs conocidas para cada ambiente
const DEV_URL = "https://yellow-island-02da8310f.4.azurestaticapps.net/login";
const PROD_URL = "https://kind-river-0d2352b0f.4.azurestaticapps.net/login";
const LOCAL_URL = "http://localhost:3000/login";

const isDev = path === LOCAL_URL || path === DEV_URL;
const isProd = path === PROD_URL;

export const msalConfig = {
  auth: {
    clientId: isDev ? clientIdDev : clientIdProd,
    authority: "https://login.microsoftonline.com/5368fc5a-2692-4a6a-b226-e2802e94e22b",
    redirectUri: isDev || isProd ? path : undefined,
  },
  acceptMappedClaims: true,
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
  prompt: "select_account",
};
